module.exports = __webpack_public_path__ + "static/media/filename (13).e213fe00.png";